export default "<ng-container *ngIf=\"aasEnabled\">\n    <authenticator [AASHost]=\"aasHost\"></authenticator>\n</ng-container>\n";